import { useApi } from '@/composables/useApi';
import type { SeoData } from '@/models/seo';

export const useApp = async () => {
  const loaded = useState('loaded', () => false);
  const fading = useState('fading', () => false);

  const nuxtApp = useNuxtApp();
  nuxtApp.hook('page:finish', () => {
    loaded.value = true;
  });

  const head = useLocaleHead();

  const loadSeoData = async () => {
    const { data, error } = await useApi<SeoData>(`/seo`);

    if (error.value) return;

    useHead({
      titleTemplate: (titleChunk) => {
        return titleChunk ? `${titleChunk} %separator %siteTitle` : '%siteTitle';
      },
      templateParams: {
        siteTitle: data.value.title ?? 'Telekom CoMind',
        separator: '|'
      },
      meta: [...head.value.meta, { name: 'description', content: data.value.description }],
      htmlAttrs: { ...head.value.htmlAttrs }
    });

    useSeoMeta({
      ogSiteName: data.value.title,
      ogTitle: data.value.ogTitle,
      ogDescription: data.value.ogDescription,
      ogImage: data.value.ogImage?.src
    });
  };

  await loadSeoData();

  return {
    loaded,
    fading
  };
};
